import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { RoleGroupService } from 'src/app/_services/role-group.service';

@Component({
  selector: 'app-add-permission-to-role',
  templateUrl: './add-permission-to-role.component.html',
  styleUrls: ['./add-permission-to-role.component.css']
})
export class AddPermissionToRoleComponent implements OnInit {
  roleGroup={}
permissions =[]
permissionCount=0
  dtOptions: DataTables.Settings = {};
  loading = false
  server_role_group_id=0
  searchRolesForm:FormGroup
  roleList=[]
  constructor(private roleGroupService:RoleGroupService, private activeRoute:ActivatedRoute) { }

    ngOnInit(): void {
      this.searchRolesForm= new FormGroup(
        {'searchInput': new FormControl('')}
        )
      this.loading=true
      this.dtOptions = {
        pagingType: 'full_numbers'
       };
       this.activeRoute.params.subscribe(
        xx=>{
          this.server_role_group_id = +xx['server_role_group_id']
          this.loadGroup()
          this.loadCount()

      this.onSearchFormChanges()

        }
      )
      }
      addPermissionToRoleGroup(id:number){
        let data = new URLSearchParams();
        data.set('roleId', id.toString());
        // this.roleGroupService.addPermissionToRoleGroup(this.server_role_group_id,data.toString()).subscribe(
        //   {
        //     next:(x:ResultData)=>{
        //       this.permissions=x.rs.data
        //       this.loading=false
        //     }
        //   }
        // )

      }
  onSearchFormChanges(): void {
    if(this.searchRolesForm!=null){
      this.searchRolesForm.get('searchInput').valueChanges.subscribe(val => {
        if(val.length>2){
          let data = new URLSearchParams();
          data.set('id',this.server_role_group_id.toString())
          data.set('q', val.toString());
          this.roleGroupService.searchAbilityToAddToAbility(data.toString(),this.server_role_group_id).subscribe(
           {
              next:(x:ResultData)=>{
                this.roleList=x.rs.data

              }
            }

          )
        }else{
          this.roleList=[]
        }
      })
    }
  }

  loadGroup(){

    this.roleGroupService.getRoleGroupName(this.server_role_group_id).subscribe(
                {next:(x:ResultData)=>{
                  this.roleGroup= x.rs.data
                }
            }
           )
  }
  loadCount(){
    this.roleGroupService.getGroupPermissionCount(this.server_role_group_id).subscribe(
      {
        next:(x:ResultData)=>{
        this.permissionCount=x.rs.data
        this.loading=false
      }

  })
  }
}
